export enum ExpressionActionTypeEnum {
  REGEX = 'REGEX',
  LITERAL = 'LITERAL',
}